import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "../components/ui/breadcrumb";
import { Input } from "../components/ui/input";

import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";
import { asKnowledgeRecord, listResults } from "../lib/thirdDoorAdapters";

export default function ResourcesFaq() {
    const [query, setQuery] = useState("");
    const { resources } = useModelIndex("knowledge_record" as any, { search: query, limit: 25 } as any);
    const items = listResults(resources).map(asKnowledgeRecord);
    const filtered = useMemo(() => items.filter((item) => item.q.toLowerCase().includes(query.toLowerCase())), [query]);
  return (
   <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <Breadcrumb>
      <BreadcrumbList>
      <BreadcrumbItem><BreadcrumbLink asChild><Link to="/resources">Resources</Link></BreadcrumbLink></BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem><BreadcrumbPage>FAQ</BreadcrumbPage></BreadcrumbItem>
      </BreadcrumbList>
      </Breadcrumb>
      <Input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search FAQ" className="max-w-md" />
      <Accordion type="single" collapsible className="rounded-lg border border-border bg-card px-4">
      {filtered.map((item) => (
      <AccordionItem key={item.q} value={item.q}>
      <AccordionTrigger>{item.q}</AccordionTrigger>
      <AccordionContent>{item.a}</AccordionContent>
      </AccordionItem>
      ))}
      </Accordion>
      </section>
      </div>
    </div>
  );
}